
import React, { useState, useEffect } from "react";
import RsuiteChecker from "../../RsuiteChecker";
import Modal from "./common/Modal";
// import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { storeLead } from "./actions/StoreLeadAction";
import toast from "react-hot-toast";

const ContactFormModal = ({
  showContactModal,
  selectedContact,
  onSave,
  closeModal,
  companyName,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [contactData, setContactData] = useState({
    id: 0,
    name: "",
    designation: "",
    email: "",
    // phone: "",
    // phoneCode: "+91",
    phone_number: "",
  });

  // Update contactData when selectedContact changes
  useEffect(() => {
    if (selectedContact) {
      const phoneParts = selectedContact.phone
        ? selectedContact.phone.split("-")
        : ["+91", ""];
      setContactData({
        ...selectedContact,
        // phoneCode: phoneParts[0] || "+91",
        // phone_number: phoneParts[1] || selectedContact.phone || "",
      });
    } else {
      setContactData({
        id: 0,
        name: "",
        designation: "",
        email: "",
        // phone: "",
        // phoneCode: "+91",
        phone_number: "",
      });
    }
  }, [selectedContact, showContactModal]);

  const handleChange = (valueFor, value) => {
    setContactData((prev) => ({ ...prev, [valueFor]: value }));
  };

  const handleSave = async () => {
    // Combine phone code and number
    // const phoneValue = contactData.phone_number
    //   ? `${contactData.phoneCode}-${contactData.phone_number}`
    //   : "";
    // const saveData = {
    //   ...contactData,
    //   phone: phoneValue,
    // };

    const saveData = {
      ...contactData,
      company_name: companyName,
      lead_source: "manual",
    };

    setIsLoading(true);

    const resp = await storeLead(saveData);
    if (resp.success) {
      onSave(saveData);
      toast.success("Lead created successfully!");
    } else {
      toast.error(
        "An error occurred while processing your request. Please try again!"
      );
    }
    setIsLoading(false);
  };

  const footer = () => {
    return (
      <React.Fragment>
        <button
          type="button"
          className="cancel-btn"
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="save-btn"
          onClick={handleSave}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </button>
      </React.Fragment>
    );
  };

  return (
    <div id="edit">
      <Modal
        isOpen={showContactModal}
        onClose={closeModal}
        title={selectedContact ? "Edit Contact" : "Add Contact"}
        className="crm"
        footer={footer()}
      >
        <div className="input-box">
          <label className="input-label" htmlFor="name">
            Name <span>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder=""
            name="name"
            value={contactData.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            disabled={isLoading}
          />
        </div>
        {/* <div className="input-box">
          <label className="input-label" htmlFor="designation">
            Designation <span>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="designation"
            value={contactData.designation || ""}
            onChange={(e) => handleChange("designation", e.target.value)}
            disabled={isLoading}
          />
        </div> */}
        <div className="input-box">
          <label className="input-label" htmlFor="email">
            Email <span>*</span>
          </label>
          <input
            type="email"
            className="form-control"
            name="email"
            value={contactData.email || ""}
            onChange={(e) => handleChange("email", e.target.value)}
            disabled={isLoading || selectedContact ? true : false}
          />
        </div>
        <div className="input-box">
          <label className="input-label" htmlFor="phone">
            Phone <span>*</span>
          </label>
          <div className="phone-wrap">
            {/* <RsuiteChecker
              data={[
                { label: "+91", value: "+91" },
                { label: "+21", value: "+21" },
                { label: "+33", value: "+33" },
                { label: "+36", value: "+36" },
              ]}
              val={contactData.phoneCode || "+91"}
              select={true}
              onChange={(value) => handleChange("phoneCode", value)}
              field_name="phoneCode"
            /> */}
            <input
              type="text"
              className="form-control"
              name="phone"
              placeholder="Enter phone number"
              value={contactData.phone_number || ""}
              onChange={(e) => handleChange("phone_number", e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContactFormModal;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ContactFormModal.js